import * as React from 'react';
import styled from 'styled-components';

import { themeGet, ContentContainer } from '@packages/ui';

const Container = styled.div`
  background: ${themeGet.colors('desertStorm')};
  color: ${themeGet.colors('swirl')};
  font-size: 1.2rem;
  font-weight: ${themeGet.fontWeight('normal')};
  padding: 10px 0;
  text-align: center;
`;

export const Copyright: React.FC<{ text: string }> = ({ text }) => (
  <Container>
    <div>V3</div>
    <ContentContainer>{text}</ContentContainer>
  </Container>
);
